import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { CompanyProfileRequest, CompanyProfileResponse } from "../types";
import { queryKeys } from "./queryKeys";

const getCompanyProfile = async (companyId: string) => {
  const { data } = await axios.get(`/company/${companyId}/profile`);
  return data;
};

export const useCompanyProfile = (companyId: string) =>
  useQuery<CompanyProfileResponse>({
    queryKey: [queryKeys.COMPANY_PROFILE, companyId],
    queryFn: () => getCompanyProfile(companyId),
    enabled: !!companyId,
    retry: false,
  });

const updateCompanyProfile = async (body: CompanyProfileRequest) => {
  const { data } = await axios.put(`/company/${body.companyId}/profile`, body);
  return data;
};

export const useUpdateCompanyProfile = (
  onSuccess: (res: CompanyProfileResponse) => void,
  onError?: (error: any) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCompanyProfile,
    onSuccess: (data: CompanyProfileResponse) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.COMPANY_PROFILE, data.id],
      });
      onSuccess(data);
    },
    onError,
  });
};
